// The pawns a sacrifice removes. One pick names the whole group, so the board
// can show the group before the click and the AI can score it.

import { SACRIFICE_GROUP_MAX } from '../constants';
import { neighborSquares } from '../engine/squares';
import type { Board, Piece } from '../engine/types';

/** A royal pawn stays out. If it were the last royal piece, its removal would end the match. */
const canBeSacrificed = (piece: Piece): boolean => piece.kind === 'pawn' && !piece.royal;

/**
 * The pawn on the square and the nearest pawns of its side that connect to it,
 * up to the largest group. A pawn connects when it is on one of the eight
 * squares around a pawn of the group. The search is breadth first in the order
 * of `neighborSquares`, so one pick always gives the same group.
 */
export const sacrificeGroup = (board: Board, square: number): number[] => {
  const picked = board[square];
  if (!picked || !canBeSacrificed(picked)) return [];
  const group = [square];
  for (let index = 0; index < group.length; index += 1) {
    for (const neighbor of neighborSquares(group[index] as number)) {
      if (group.length === SACRIFICE_GROUP_MAX) return group;
      const piece = board[neighbor];
      if (!piece || piece.owner !== picked.owner || !canBeSacrificed(piece)) continue;
      if (!group.includes(neighbor)) group.push(neighbor);
    }
  }
  return group;
};
